import { Button, Card, Header, ListItem } from "semantic-ui-react";
import { ReferenceLibraryElementLink } from "./ReferenceLibraryElementLink";
import { NewNewModalWithFormComponent } from "src/components/new_modal/NewNewModalWithFormComponent";
import { CREATE_REFERENCE_LIBRARY_ELEMENT } from "src/routes/mutations";
import { NewNewFormComponentProps } from "src/components/new_form/NewNewFormComponent";
import { getReferenceLibraryForm } from "./reference_library_form";

export const LinkedReferenceLibraryElementsSection = (props: {
  data: any;
  setReloadKey: any;
}) => {
  return (
    <Card.Content className="linked-reference-library-elements">
      <Header>Linked Reference Library Elements</Header>
      {props.data.referenceLibraryElements.map(
        (element: {
          id: number;
          name: string;
          type: number;
          physicalLibraryLocation?: { id: number; name: string };
          body?: string;
          elements?: { id: number; name: string; type: number };
        }) => (
          <ReferenceLibraryElementLink props={element} />
        ),
      )}
      <NewNewModalWithFormComponent
        props={{
          header: "Create Reference Library Element",
          triggerProps: {
            type: "button",
            label: "Create Reference Library Element",
          },
          callback: () => props.setReloadKey((prev: number) => prev + 1),
          apiCall: {
            documentNode: CREATE_REFERENCE_LIBRARY_ELEMENT,
            key: "createReferenceLibraryElement",
          },
          formComponentProps: new NewNewFormComponentProps({
            form: getReferenceLibraryForm(),
            startingData: {
              name: "",
              type: 1,
              elementIds: [props.data.id],
              body: "",
              physicalLibraryLocationId: undefined,
            },
          }),
        }}
      />
    </Card.Content>
  );
};
